import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemButtonGroup from '../FormItemButtonGroup';
import CmdTypeActions from '../../actions/CmdTypeActions';


export default class FormItemButtonGroupControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemButtonGroupControl";
	}

	getProperty_MainContentAlignment()
	{
		return this.properties.MainContentAlignment;
	}

	updateControlAllowEdit(arg)
	{
		if(arg && arg.hasOwnProperty(this.xml.name))
		{
			var _arg = {};var _allowEdit = arg[this.xml.name];
			for(let i = 0;i<this.xml.FormItem.length;i++)
			{
				var item = this.xml.FormItem[i];
				_arg[item.name] = _allowEdit;
			}
			CmdTypeActions.updateControlAllowEdit(_arg);
		}
	}

	getStyle()
	{
		let superStyle = super.getStyle();
		if(superStyle)
		{
			let justifyContent = this.getProperty_MainContentAlignment();
			if(!justifyContent)justifyContent = "flex-start";
			superStyle.justifyContent = justifyContent;
		}
		return superStyle;
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
		this.component =  <FormItemButtonGroup key={this.xml.id} xml={this.xml} 
                parentLayout={layout} forLookup={forLookup} moduleInstanceId={this.module.instanceUUId} 
                groupAlias={this.groupAlias} customStyle={this.getStyle()}
                formId={this.formId} menuItemId={this.menuItemId} contextMenuData={this.contextMenuData}
                control={this} {...commonProps}/>;
        return this.component;
    }
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemButtonGroupControl.js